<template>
    <div>
        <Menu ref="sideMenu" accordion :active-name="anchorName" :open-names="openMenu" @on-select="handleSelectMenu">
                <Submenu name="1">
                    <template slot="title">
                        名词解释
                    </template>
                    <MenuItem name="1-1">1.1 关键字</MenuItem>
                    <MenuItem name="1-2">1.2 相关度</MenuItem>
                    <MenuItem name="1-3">1.3 商业成熟度</MenuItem>
                    <MenuItem name="1-4">1.4 交通枢纽性</MenuItem>
                    <MenuItem name="1-5">1.5 站点客流量</MenuItem>
                </Submenu>
                <Submenu name="2">
                    <template slot="title">
                        站点搜索
                    </template>
                    <MenuItem name="2-1">2.1 数据范围</MenuItem>
                    <MenuItem name="2-2">2.2 列表搜索</MenuItem>
                    <MenuItem name="2-3">2.3 线路图展示</MenuItem>
                </Submenu>
                <Submenu name="3">
                    <template slot="title">
                        个性化
                    </template>
                    <MenuItem name="3-1">3.1 关键字</MenuItem>
                    <MenuItem name="3-2">3.2 参数</MenuItem>
                    <MenuItem name="3-3">3.3 城市</MenuItem>
                </Submenu>
                <Submenu name="4">
                    <template slot="title">
                        报告生成
                    </template>
                    <MenuItem name="4-1">4.1 关注列表</MenuItem>
                    <MenuItem name="4-2">4.2 报告预览</MenuItem>
                    <MenuItem name="4-3">4.3 报告下载/分享</MenuItem>
                </Submenu>
            </Menu>
    </div>
</template>

<script>
export default {
  data () {
    return {
      anchorName: '1-1', // 锚点名称
      openMenu: ['1']
    }
  },
  mounted () {
    this.$nextTick(() => {
    //   if (this.$refs.sideMenu) {
    //     this.$refs.sideMenu.updateOpened()
    //   }
    })
  },
  methods: {
    handleSelectMenu (name) {
      window.location.href = '/help/#' + name
    }
  }
}
</script>
